/* istanbul ignore file */
import { useSelector } from 'react-redux';
import { OccupancyType } from '@common/entities';
import { queryClient } from 'AppWrapper';
import { RootState } from 'state/store';

import { getReservedUnitForApplicant } from 'services';
import handleError from 'utils/handleError';

export function useCheckIsUnitReserved() {
  const { occupancyType } = useSelector((state: RootState) => state.application.form);

  async function checkIsUnitReserved(unitSpaceId: number, propertyId: number): Promise<boolean> {
    if (!propertyId) {
      handleError(`Form Viewer - Property ID missing`, `Property ID missing`);
      return false;
    }

    // For student occupancy, skip the reservation check
    const isStudentOccupancy = occupancyType === OccupancyType.Student;
    if (isStudentOccupancy) {
      return true; // Assume unit is available for student occupancy
    }

    try {
      const { data } = await queryClient.fetchQuery({
        queryKey: ['reserve-unit', propertyId],
        queryFn: () => getReservedUnitForApplicant(propertyId),
      });

      if (!data?.unitSpaceId) return false;

      return Number(data.unitSpaceId) === unitSpaceId;
    } catch {
      return false;
    }
  }

  return checkIsUnitReserved;
}
